import { videoRoomsApi } from '../services/videoRoomsApi';

/** Mux credentials stay on the Hostinger PHP server. */
export const MUX_CONFIG = { rtmpUrl: 'rtmp://global-live.mux.com:5222/app' };

export const DEFAULT_LIVE_STREAM_CONFIG = {
  playbackPolicy: ['public'] as const,
  reconnectWindow: 60,
};

export function createMuxLiveStream(streamId: string, hostId: string, title: string, description?: string) {
  return videoRoomsApi.createMuxStream(streamId, hostId, title, description);
}

export async function endMuxLiveStream(streamId: string): Promise<void> {
  await videoRoomsApi.endMuxStream(streamId);
}

export function getMuxPlaybackUrl(playbackId: string): string {
  return `https://stream.mux.com/${playbackId}.m3u8`;
}

export default MUX_CONFIG;
